module.exports = __webpack_public_path__ + "media/images/circle_bullet-4cd963ad23db71e873059982c22207c5.png";